<div class="sidePanelEmptyFolderMessage">
  <div class="sidePanelEmptyFolderMessage__inner">
    {{ 'folder_empty' | ppTranslate }}
  </div>
</div>
